<div class="filter-item">
  <a mat-button class="primary-menu-button" [matMenuTriggerFor]="auctionTypeFilter">
    <span class="pr-2" [class.primary-color]="!allTypesSelected">{{ menuLabel }}</span>
    <mat-icon iconPositionEnd class="menu-expand-icon">arrow_drop_down</mat-icon>
  </a>

  <mat-menu #auctionTypeFilter="matMenu" (closed)="onMenuClosed($event)">
    <div>
      <div class="ml-3"><b>Listing Type</b></div>

      <button mat-menu-item (click)="$event.stopPropagation()">
        <mat-checkbox
          color="primary"
          class="primary-checkbox"
          [checked]="auctionTypeSelection.isEmpty()"
          (change)="toggleAllTypes($event.checked)">
          All
        </mat-checkbox>
      </button>

      @for (at of auctionTypes; track at.id) {
        <button mat-menu-item (click)="$event.stopPropagation()">
          <mat-checkbox
            color="primary"
            class="primary-checkbox"
            [checked]="isAuctionTypeChecked(at)"
            (change)="toggleAuctionType(at)">
            {{ at.name }}
          </mat-checkbox>
        </button>
      }
    </div>

    <div class="flex-row space-between items-center px-2 py-2 sticky">
      <a color="primary" mat-button (click)="onClearClick()">Clear</a>
      <button mat-flat-button color="primary" mat-button (click)="onApplyClick()">Apply</button>
    </div>
  </mat-menu>
</div>